import { useEffect, useState } from 'react';
import { FEATURE_SWITCH_NAMES } from '../constants/feature-switch-names';
import featureAvailability from '../services/feature-availability';
import abAvailability from '../services/ab-availability';

const useFeatureSwitch = (featureName: FEATURE_SWITCH_NAMES, fullInfo = false) => {
    const [value, setValue] = useState(false);
    const [fullValue, setFullValue] = useState<UnleashRespT>();
    const service = fullInfo ? abAvailability : featureAvailability;

    useEffect(() => {
        service.get(featureName).then((response) => {
            fullInfo ? setFullValue(response?.variant) : setValue(Boolean(response?.is_enabled));
        });
    }, []);

    return fullInfo ? fullValue : value;
};

export default useFeatureSwitch;
